<footer>
    <div class="footer-content">
        <div role="contentinfo" class="links-wrapper">
            <a mat-button [href]="linkTermsConditions" target="_blank">{{
                termsConditions
                }}</a>
            <a mat-button [href]="linkPrivacyPolicy" target="_blank">{{
                privacyPolicy
                }}</a>
            <a mat-button [href]="linkCookiesPolicy" target="_blank">{{
                cookiesPolicy
                }}</a>
        </div>
        <div class="right">
            <div role="contentinfo" class="version">
                <span class="app-version">Versión: {{ version }}</span>
            </div>
        </div>
    </div>
</footer>
